import React from 'react';
import moment from 'moment';
import { ENTRY_WIDTH_UNIT } from '../../../../constants/styling/styles';
import { differenceInMinutes } from '../../../../lib/date.utils';

const isHourInRange = (hourString, startMs, endMs) => {
    if (!startMs || !endMs) return false;
    
    // Parse the hour string (e.g., "21:00" or "21:30") into minutes from midnight
    const [hours, minutes] = hourString.split(':').map(Number);
    const hourMinutes = hours * 60 + minutes;
    
    // Convert entry start/end to minutes from midnight (UTC)
    const startMoment = moment.utc(startMs);
    const endMoment = moment.utc(endMs);
    const startMinutes = startMoment.hours() * 60 + startMoment.minutes();
    const endMinutes = endMoment.hours() * 60 + endMoment.minutes();
    
    // Handle overnight ranges (e.g., 23:00 to 02:00)
    if (endMinutes < startMinutes) {
        return hourMinutes >= startMinutes || hourMinutes < endMinutes;
    }
    
    return hourMinutes >= startMinutes && hourMinutes < endMinutes;
};

const calculateIndicatorPosition = (minHour, startMs, zoom) => {
    const difference = differenceInMinutes(minHour, startMs);
    return (difference / 60) * (ENTRY_WIDTH_UNIT * zoom);
};

const calculateIndicatorWidth = (startMs, endMs, zoom) => {
    const difference = differenceInMinutes(startMs, endMs);
    return (difference / 60) * (ENTRY_WIDTH_UNIT * zoom);
};

const Hours = ({ hours, marginLeft, nowButton, nowOnClick, zoom, minHour, hoveredEntryStart, hoveredEntryEnd }) => {
    const isHovered = hoveredEntryStart && hoveredEntryEnd;
    const indicatorStyle = isHovered ? {
        left: calculateIndicatorPosition(minHour, hoveredEntryStart, zoom),
        width: calculateIndicatorWidth(hoveredEntryStart, hoveredEntryEnd, zoom),
        opacity: 0.85
    } : {};

    return (
        <ul
            className="ckp-timetable-hours"
            style={{ marginLeft: marginLeft, width: (hours.length / 2) * (ENTRY_WIDTH_UNIT * zoom) }}
        >
            {nowButton ? (
                <a onClick={nowOnClick} style={{ left: -marginLeft }} className="ckp-timetable-hours-now ckp-ts-h3">
                    Now
                </a>
            ) : null}
            <div 
                className="ckp-timetable-hours-indicator"
                style={indicatorStyle}
            />
            {hours.map((h, i) => {
                const isHighlighted = isHourInRange(h, hoveredEntryStart, hoveredEntryEnd);
                return (
                    <li key={i} style={{ minWidth: (ENTRY_WIDTH_UNIT * zoom) / 2 }} className={`ckp-timetable-hour ${isHighlighted ? 'is-highlighted' : ''}`}>
                        <span className="ckp-timetable-hour-text">{h}</span>
                    </li>
                );
            })}
        </ul>
    );
};

export default Hours;
